<!-- Proposed Solution List Table -->
<div class="card table-container" >
    <div class="card-body" id="proposedsolution_card_body">
        <!-- <div id="item_container"> -->

        <table id="proposedsolution_table">
            <!-- <thead> -->
            <tr id="proposedsolution_table_header" class="cust-table-header">
            
                <th (click)="sort('kbaId')" style="flex: 0 0 100px;" id="kbaId">
                    <em class="fa fa-sort"
                        [ngClass]="{'fas fa-sort-down': (column == 'kbaId' && isDesc), 'fas fa-sort-up': (column == 'kbaId' && !isDesc) }"
                        aria-hidden="true">
                    </em>
                    {{ 'ProposedSolutionList.kbaId' | translate }}
                </th>
                <th  (click)="sort('kbaTypeIndex')" style="flex: 0 0 100px;" id="kbaType">
                    <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'kbaTypeIndex' && isDesc), 'fas fa-sort-up': (column == 'kbaTypeIndex' && !isDesc) }"
                    aria-hidden="true">
                </em>
                    {{ 'ProposedSolutionList.kbaType' | translate }}
                </th>
            
                <th  (click)="sort('summary')"style="flex: 0 0 100px;" id="summary">
                    <em class="fa fa-sort"
                    [ngClass]="{'fas fa-sort-down': (column == 'summary' && isDesc), 'fas fa-sort-up': (column == 'summary' && !isDesc) }"
                    aria-hidden="true">
                </em>
                    {{ 'ProposedSolutionList.summary' | translate }}
                </th>
                <th (click)="sort('relevance')" style="flex: 0 0 100px;" id="relevance">
                    <em class="fa fa-sort"
                        [ngClass]="{'fas fa-sort-down': (column == 'relevance' && isDesc), 'fas fa-sort-up': (column == 'relevance' && !isDesc) }"
                        aria-hidden="true">
                    </em>
                    {{ 'ProposedSolutionList.relevance' | translate }}
                </th>
            
            </tr>
            <tbody > 
            <tr class="table-body" *ngFor="let kba of requestProposedSolutionBasicInfo | sortList:column:order:columnTypeNumber ; let i=index;trackBy: trackByItems" 
            id="proposedsolution_table_body" (click)=showDetail(kba.kbaId)>
                <td> {{kba.kbaId}}</td>
                <td>
                   <span *ngIf="kba.kbaTypeIndex === ARTICLE_INDEX" > {{ 'ProposedSolutionList.article' | translate }}</span>
                   <span *ngIf="kba.kbaTypeIndex === FAQ_INDEX" > {{ 'ProposedSolutionList.faq' | translate }}</span>
                   <span *ngIf="kba.kbaTypeIndex === SOLUTION_INDEX" > {{ 'ProposedSolutionList.solution' | translate }}</span>
                </td>
                <td>{{ kba.summary }}</td>
                <td  *ngIf="kba.relevance !== 0; else elseBlock">{{ kba.relevance }} %</td>
                <ng-template #elseBlock> <td>{{ 'ProposedSolutionList.notAvailable' | translate }}</td></ng-template>
            </tr>        
            </tbody>
        </table>
    </div>
</div>
 
<div *ngIf=viewDetail id="proposedsolution_detail">
    <span class="zsd-cust-common-pageheading-font mt-2"> {{ 'ProposedSolution.selectedproposedsolution' | translate }} </span>
    <div class="row mt-2">        
        <div class="col-lg-12 col-xl-12 col-md-12 col-xs-12 col-sm-12 col-12">
            <zsd-proposedsolutiondetail [kbaId]=kbaId [requestId]=requestId></zsd-proposedsolutiondetail>
        </div>
    </div>
</div>
